module.exports = __webpack_public_path__ + "img/cs-logo-1-blanco.5f284497.svg";